export default __webpack_public_path__ + "static/media/app-mockup.b41c7a3a.png";